import axios from 'axios'

const API_PATH = 'api/v2/admins/users'

const UserAddressesApiV2 = {

  show: async (id) => {
    const path     = `${API_PATH}/addresses/${id}`
    const response = axios.get(path)
    return response
  },

  /**
   * Update User address
   * @param {number} id User address id
   * @param {number} payload request data
   */
  updateAddress: async (id, payload) => {

    const path = `${API_PATH}/addresses/${id}`

    const response = axios.patch(path, payload)
    return response
  },

  /**
   * Create User address
   * @param {object} params payload request data
   */
  createAddress: async (params) => {

    const path =  `${API_PATH}/addresses`

    const response = axios.post(path, params)
    return response
  }

}

export default UserAddressesApiV2
